var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children } from "react";
import PropTypes from "prop-types";
var NavItemBody = function (props) {
    var 
    // @ts-ignore
    label = props.label, children = props.children, title = props.title, _a = props.titleAs, titleAs = _a === void 0 ? "h4" : _a, className = props.className, 
    // @ts-ignore
    __TYPE = props.__TYPE, remainingProps = __rest(props, ["label", "children", "title", "titleAs", "className", "__TYPE"]);
    //const [active, setActive] = useState<number>();
    var navLink = Children.toArray(children).filter(function (child) {
        // @ts-ignore
        return child && child.props && child.props.__TYPE === "NavLink";
    });
    var getActive = function (e) {
        var elements = document.querySelectorAll(".fr-nav__link");
        elements.forEach(function (element) {
            if (e.target === element) {
                element.setAttribute("aria-current", "page");
            }
            else {
                element.removeAttribute("aria-current");
            }
        });
    };
    return (React.createElement("div", __assign({ className: "fr-col-12 fr-col-lg-3" }, remainingProps),
        React.createElement("h5", { className: "fr-mega-menu__category" }, label),
        React.createElement("ul", { className: "fr-mega-menu__list" }, Children.toArray(navLink).map(function (child, index) { return (React.createElement("li", { key: index, onClick: function (e) { return getActive(e); } }, child)); }))));
};
NavItemBody.defaultProps = { __TYPE: "NavItemBody" };
NavItemBody.propTypes = { __TYPE: PropTypes.string };
export default NavItemBody;
